import { Button } from "@studyplus/boron-ui";
import { ErrorMessage, Field, Form, Formik, FormikHelpers } from "formik";
import * as React from "react";
import ErrorText from "../../../../components/atoms/ErrorText/index";
import Input from "../../../../components/atoms/Input/index";
import { UnprocessableEntityError } from "../../../../errors";
import { useFlashMessage } from "../../../../hooks/useFlashMessage";
import { HTTP_ERROR_MESSAGE } from "../../../../reducers/index";
import ApiErrors from "./ApiErrors";
import styles from "./styles.scss";
import { useInviteOperator } from "./useInviteOperator";
import validationSchema from "./validationSchema";

interface Props {
  sectionId: string;
}

interface Values {
  email: string;
}

const InviteOperatorForm: React.FC<Props> = (props) => {
  const { mutate: inviteOperator, isPending, apiErrors } = useInviteOperator();
  const { showSuccessMessage, showErrorMessage } = useFlashMessage();

  const initialValues: Values = {
    email: "",
  };

  const handleSubmit = (
    values: Values,
    { resetForm }: FormikHelpers<Values>,
  ) => {
    inviteOperator(
      { sectionId: props.sectionId, email: values.email },
      {
        onSuccess: () => {
          showSuccessMessage("招待を送信しました");
          resetForm();
        },
        onError: (error) => {
          if (error instanceof UnprocessableEntityError) {
            showErrorMessage("招待を送信できませんでした");
          } else {
            showErrorMessage(HTTP_ERROR_MESSAGE);
          }
        },
      },
    );
  };

  return (
    <div className={styles.root}>
      {apiErrors && <ApiErrors errors={apiErrors} />}
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isValid }) => (
          <Form>
            <ErrorMessage name="email" component={ErrorText} />
            <Field
              type="email"
              name="email"
              component={Input}
              className={styles.input}
              placeholder={"招待するメールアドレスを入力"}
            />
            <Button
              disabled={!isValid || isPending}
              className={styles.btn}
              type="submit"
            >
              メンバー招待
            </Button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default InviteOperatorForm;
